import { Layout } from 'react-admin';
import { MySidebar } from '../sidebar/Sidebar.tsx';
import { MyMenu } from '../menu/Menu.tsx';
import Appbar from '../appbar/Appbar.tsx';

export const MyLayout = (props: any) => (
  <Layout {...props} sidebar={MySidebar} menu={MyMenu}  appBar={Appbar}/>
);
